import { type ProductData, ProductMarketType } from "~/domains/product/types/ProductData";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { type ImageDataDTO, type ImageFormat, ImageType } from "~/domains/product/types/ProductDataDTO";
import { uniqueValues } from "~/common/utils/misc";

export function canUseCommentsForProduct(marketType: ProductMarketType | null) {
  if (marketType === ProductMarketType.DMA) {
    return userHasPermission(Permission.ADD_VIEW_COMMENTS_DMA);
  }
  if (marketType === ProductMarketType.PMA) {
    return userHasPermission(Permission.ADD_VIEW_COMMENTS_PMA);
  }
  return false;
}

export function getProductImage(product: Pick<ProductData, "images">, format: ImageFormat): ImageDataDTO | undefined {
  return product.images.filter((img) => img.format === format && img.imageType === ImageType.primary)[0];
}

export function hasSuccessor(product?: {
  successorProduct?: Pick<ProductData, "url" | "designation">;
}): product is { successorProduct: Pick<ProductData, "url" | "designation"> } {
  return !!product?.successorProduct;
}

export function makeCADUrl(product: Pick<ProductData, "url">) {
  return product.url + "?cad#tabs";
}

export function makeCalcUrl(product: Pick<ProductData, "url">) {
  return product.url + "?calc#tabs";
}

export function isSubscription(product: Pick<ProductData, "quantityVisible">) {
  return !product.quantityVisible;
}

export function getTariffNumbers(product: Pick<ProductData, "fifteenDigit">) {
  return (
    uniqueValues(
      Object.values(product.fifteenDigit)
        .map((digit) => digit.customsData)
        .flat(),
    ) || []
  );
}
